module.exports = __webpack_public_path__ + "static/media/edunomics_logo.683ce4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/AnnotationTool/landingPage/edunomics_logo.png
// module id = 243
// module chunks = 0